import api from './api';

export const estimationService = {
  getEstimations: async (filters = {}) => {
    let url = '/estimations';
    if (filters.status && filters.status !== 'all') {
      url += `?status=${filters.status}`;
    }
    const response = await api.get(url);
    return response.data;
  },

  updateEstimationStatus: async (id, status, approvalNotes = '') => {
    const response = await api.put(`/estimations/${id}/status`, {
      status,
      approval_notes: approvalNotes
    });
    return response.data;
  }
};
